module.exports = __webpack_public_path__ + "img/ch-health.e8a5fa4e.jpg";